import * as React from "react";
const LoadersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#ffff"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7Z"
    />
    <circle cx={5} cy={20} r={2} stroke="#ffff" strokeWidth={1.5} />
    <path
      stroke="#ffff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5 18V4a2 2 0 0 0-2-2H2M7 20h15M13 8h2"
    />
  </svg>
);
export default LoadersIcon;
